import { useRef, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import Iconify from "../../../components/Iconify";
import React from "react";

import FrmDelegadosReporte from "../modals/FrmDelegadosReporte";
const MenuDateDelegados = ({
  setOpenDialog,
  setBodyDialog,
  setDatos,
  setTitle,
}) => {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);


  const handleOpenReportByDates = (e) => {
    //setTitle("Reporte por Fechas");
    setBodyDialog(
      <FrmDelegadosReporte
        setTitle={setTitle}
        setOpenDialog={setOpenDialog}
        setDatos={setDatos}
      />
    );
    setOpenDialog(true);
  };
  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          component={RouterLink}
          to="#"
          sx={{ color: "text.secondary" }}
        >
          <ListItemIcon>
            <Iconify icon="eva:edit-fill" width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Reporte por Rango de Fechas"
            primaryTypographyProps={{ variant: "body2" }}
            onClick={() => handleOpenReportByDates()}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default MenuDateDelegados;
